module.exports = __webpack_public_path__ + "83afc66b03a64a71855ae3d2ae1295be.png";